import {NextPage} from "next";
import Head from "next/head";
import {wrapper} from "../app/store";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {MacroPlanView} from "../components/macroPlan/MacroPlanView";

const MacroPlan: NextPage = () => {
  return <>
    <Head>
      <title>Your Macro Plan</title>
    </Head>
    <MacroPlanView />
  </>
}

export const getStaticProps = wrapper.getStaticProps(store => async ({ locale }: any) => {
  return {
    props: {
      ...await serverSideTranslations(locale, ['common', 'landing', 'auth', 'location', 'store', 'payment', 'checkout', 'order', 'affiliate', 'macro_plan']),
    }
  }
});

export default MacroPlan